/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import { removeItemsFromStack } from '../../../analytics';

export default (set, get, target, productArray) => set(produce(get(), (draft) => {
  if (!draft.digitalData) {
    draft.digitalData = {};
  }

  const trackRemoveItemsFromStack = {
    target, productArray
  };

  draft.digitalData.removeItemsFromStack = trackRemoveItemsFromStack;

  removeItemsFromStack(trackRemoveItemsFromStack);
}), false, { type: 'TRACK_REMOVE_ITEMS_FROM_STACK' });
